export default "__VITE_ASSET__DR1pVvhv__"